import { useClubData } from '../lib/club-data.context';

/**
 * Hook to fetch calendar events for the user's club
 * Uses the ClubDataContext to access centralized calendar data
 */
export const useClubCalendar = () => {
  const { calendarEvents, isLoading, error } = useClubData();
  
  return { 
    events: calendarEvents,
    isLoading,
    error
  };
};